module.exports = __webpack_public_path__ + "assets/bee69450a6aa543ec5d36b7f2641ad10.svg";